import React from "react";
import {Typography} from "@mui/material";
import LockTwoToneIcon from "@mui/icons-material/LockTwoTone";
import clsx from "clsx";

const ActionTile = ({
	action,
	className,
	classes,
	colors,
	descriptionLimit = 82,
	disabled = false,
	onSelect,
}) => {
	const [color, color2] = colors;
	const description = action.description || "";
	const renderedDescription = description.substring(0, descriptionLimit);

	return (
		<div
			role="button"
			tabIndex={0}
			className={clsx(classes.actionTile, disabled && classes.actionTileLocked, className)}
			style={{
				"--action-color": color,
				"--action-color-2": color2,
			}}
			onClick={onSelect}
			onKeyDown={(event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					onSelect();
				}
			}}
		>
			<div className={classes.actionIcon}>
				{action.iconRoundedNoStyle || action.iconNoStyle || action.icon}
			</div>
			<div className={classes.actionTileContent}>
				<div className={classes.actionTileTitleRow}>
					<Typography className={classes.actionName}>{action.name}</Typography>
					{disabled && (
						<span className={classes.actionStatusPill}>
							<LockTwoToneIcon/>
							Richiedi accesso
						</span>
					)}
				</div>
				<Typography className={classes.actionDescription}>
					{renderedDescription}
					{description.length > descriptionLimit ? "..." : ""}
				</Typography>
			</div>
		</div>
	);
};

export default React.memo(ActionTile);
